export default __webpack_public_path__ + "static/media/b1.eae40c2c.png";